import { hapticFeedback } from "@telegram-apps/sdk-react";
import clsx from "clsx";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { postAddFavoriteToken, postRemoveFavoriteToken } from "~/api/endpoints";
import { ButtonCell } from "~/components/ButtonCell/ButtonCell";
import {
    IconStarFilled,
    IconStarOutline,
} from "~/components/Iconfont/Iconfont";
import { useSnackbar } from "~/Provider/Snackbar";

type TokenFavoriteBtnProps = {
    chain_id?: string;
    contract?: string;
    isFavorite: boolean;
    setIsFavorite: (isFavorite: boolean) => void;
    updateFavoriteCache: (isFavorite: boolean) => void;
};

const TokenFavoriteBtn: React.FC<TokenFavoriteBtnProps> = ({
    chain_id,
    contract,
    isFavorite,
    setIsFavorite,
    updateFavoriteCache,
}) => {
    const { t } = useTranslation();
    const snackbar = useSnackbar();

    const [favoriteLoading, setFavoriteLoading] = useState(false);
    const handleFavoriteClick = () => {
        if (favoriteLoading) return;
        if (!chain_id) return;
        if (!contract) return;

        setFavoriteLoading(true);
        hapticFeedback.impactOccurred("light");

        if (isFavorite) {
            setIsFavorite(false);
            postRemoveFavoriteToken(chain_id, contract)
                .then(() => updateFavoriteCache(false))
                .catch((err) => {
                    snackbar.error(
                        "Operation Failed, Please try again later!",
                        err
                    );
                    setIsFavorite(true);
                })
                .finally(() => setFavoriteLoading(false));
        } else {
            setIsFavorite(true);
            postAddFavoriteToken(chain_id, contract)
                .then(() => updateFavoriteCache(true))
                .catch((err) => {
                    snackbar.error(
                        "Operation Failed, Please try again later!",
                        err
                    );
                    setIsFavorite(false);
                })
                .finally(() => setFavoriteLoading(false));
        }
    };

    return (
        <ButtonCell
            className="!flex-none !w-[55px] !h-[44px] px-0 py-0 overflow-hidden"
            onClick={handleFavoriteClick}
        >
            <div className="w-[55px] flex flex-col items-center justify-center h-[44px] rounded-[12px] bg-transparent">
                {isFavorite ? (
                    <IconStarFilled className="text-text_1 text-h4" />
                ) : (
                    <IconStarOutline className="text-text_1 text-h4" />
                )}
                <div
                    className={clsx(
                        "text-direction3 font-Regular whitespace-nowrap mt-[2px] text-text_1"
                    )}
                >
                    {t("favorite")}
                </div>
            </div>
        </ButtonCell>
    );
};

export default TokenFavoriteBtn;
